import { Global, css } from "@emotion/react";
import { useTheme } from "./useTheme";

const FONT_FAMILY = '"Instrument Sans", sans-serif';

const fontFaces = css`
  @font-face {
    font-family: "Instrument Sans";
    src: url("/fonts/InstrumentSans-VariableFont_wdth,wght.woff2")
      format("woff2");
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Instrument Sans";
    src: url("/fonts/InstrumentSans-Italic-VariableFont_wdth,wght.woff2")
      format("woff2");
    font-weight: 100 900;
    font-style: italic;
    font-display: swap;
  }
`;

export const GlobalStyles = () => {
  const theme = useTheme();

  return (
    <Global
      styles={[
        fontFaces,
        css`
          *,
          *::before,
          *::after {
            box-sizing: border-box;
          }

          html,
          body {
            margin: 0;
            padding: 0;
          }

          :root {
            --scrollbar-width: 6px;
            font-family: ${FONT_FAMILY};
            line-height: 1.5;
            font-weight: 400;
            background-color: #fff;
            color: ${theme.text.colors.primary};
            color-scheme: light dark;
            font-synthesis: none;
            text-rendering: optimizeLegibility;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }

          p {
            margin: 0;
            padding: 0;
          }

          a {
            color: inherit;
          }

          @media print {
            html,
            body {
              margin: 0;
              padding: 0;
              height: auto;
              overflow: visible;
            }

            #root {
              margin: 0;
              padding: 0;
            }
          }

          &::-webkit-scrollbar {
            width: var(--scrollbar-width);
            height: var(--scrollbar-width);
            border-radius: 4px;
          }

          *::-webkit-scrollbar-track {
            background: transparent;
          }

          *::-webkit-scrollbar-thumb {
            background: ${theme.text.colors.primary};
            border-radius: 0.5rem;

            &:hover {
              background: ${theme.text.colors.secondary};
            }
          }

          ${theme.media.laptopDown} {
            &::-webkit-scrollbar {
              width: 0;
              height: 0;
            }
          }

          .Toastify__toast {
            font-family: ${FONT_FAMILY};
            font-weight: 600;
            border-radius: 0.5rem;
            box-shadow: ${theme.toast.boxShadow};
          }

          .Toastify__toast--default .Toastify__toast-body,
          .Toastify__toast--warning .Toastify__toast-body {
            color: ${theme.text.colors.primary};
          }

          .Toastify__toast--info {
            background-color: ${theme.toast.info.background};
            --toastify-icon-color-info: ${theme.toast.info.text};
            --toastify-color-progress-info: ${theme.toast.info.text};
          }

          .Toastify__toast--info .Toastify__toast-body {
            color: ${theme.toast.info.text};
          }

          .Toastify__toast--success {
            background-color: ${theme.toast.success.background};
            --toastify-icon-color-success: ${theme.toast.success.text};
            --toastify-color-progress-success: ${theme.toast.success.text};
          }

          .Toastify__toast--success .Toastify__toast-body {
            color: ${theme.toast.success.text};
          }

          .Toastify__toast--error {
            background-color: ${theme.toast.error.background};
            --toastify-icon-color-error: ${theme.toast.error.text};
            --toastify-color-progress-error: ${theme.toast.error.text};
          }

          .Toastify__toast--error .Toastify__toast-body {
            color: ${theme.toast.error.text};
          }

          .Toastify__close-button {
            color: ${theme.toast.info.text};
            opacity: 0.7;
            align-self: center;
          }

          .Toastify__close-button:hover {
            opacity: 1;
          }
        `,
      ]}
    />
  );
};
